// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Table, Button, Space, message } from 'antd'
import PopupModal from './modal'
import styles from './index.module.scss'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import {
  DELETE_CONNECTION,
  DELETE_CONNECTION_MAPPING,
  DELETE_MAPPING,
  GET_CONNECTION,
  decryptData,
  GET_MAPPING // Add the API to get mappings
} from '../../util'
import Header from '../header/header'
import MappingModal from './MappingModel' // Modal for adding/editing mappings
import UploadModal from './UploadModel'

const Connections = () => {
  const navigate = useNavigate()
  const [connections, setConnections] = useState([])
  const [mappings, setMappings] = useState({}) // Store mappings for each connection
  const [popupOpen, setIsPopupOpen] = useState(false)
  const [mappingPopupOpen, setMappingPopupOpen] = useState(false) // Modal for mapping
  const [uploadPopupOpen, setUploadPopupOpen] = useState(false) // Modal for mapping
  const [editConnection, setEditConnection] = useState(null)
  const [connectionId, setConnectionId] = useState(null)
  const [editMapping, setEditMapping] = useState(null) // State for editing mapping
  const [resetMapping, setResetMapping] = useState(false)

  const fetchData = () => {
    const userId = localStorage.getItem('userId')
    if (!userId) {
      navigate('/')
    }
    axios.get(`${GET_CONNECTION}`).then(resp => {
      const decrypted = decryptData(resp.data.encryptedData)
      setConnections(decrypted)
    })
  }

  useEffect(() => {
    fetchData()
  }, [popupOpen])

  // Fetch mappings for a specific connection
  const fetchMappings = connectionId => {
    axios.post(`${GET_MAPPING}/${connectionId}`).then(resp => {
      setMappings(prev => ({
        ...prev,
        [connectionId]: resp.data
      }))
    })
  }

  // Open modal for adding/editing mapping
  const handleCreateMapping = connectionId => {
    setConnectionId(connectionId)
    setEditMapping(null)
    setMappingPopupOpen(true)
  }

  const handleUploadMapping = connectionId => {
    setConnectionId(connectionId)
    setUploadPopupOpen(true)
  }

  const handleUpdate = record => {
    setEditMapping(record)
    setMappingPopupOpen(true)
  }

  const handleEdit = record => {
    setEditConnection(record)
    setIsPopupOpen(true)
  }

  const handleDelete = record => {
    axios.delete(`${DELETE_CONNECTION}/${record.connectionName}`).then(resp => {
      fetchData()
    })
  }

  const handleAllClearMapping = connectionId => {
    axios
      .delete(`${DELETE_CONNECTION_MAPPING}/${connectionId.id}`)
      .then(resp => {
        fetchMappings(connectionId.id)
      })
  }

  const handleDeleteMapping = (record, data) => {
    axios.delete(`${DELETE_MAPPING}/${record.id}`).then(resp => {
      fetchMappings(record.connectionId)
    })
  }

  const handleCloseMappingModel = () => {
    setMappingPopupOpen(false)
    setEditMapping(null)
    setResetMapping(false)
  }
  const handleCloseUploadModel = () => {
    setUploadPopupOpen(false)
    setEditMapping(null)
    setResetMapping(false)
  }
  const onClose = () => {
    setIsPopupOpen(null)
    setEditConnection(null)
  }

  const addNewConnection = () => {
    setEditConnection(null)
    setIsPopupOpen(true)
  }

  // Nested table for showing mappings (source and destination)
  const expandedRowRender = record => {
    const mappingData = mappings[record.id] || []
    const columns = [
      {
        title: 'Key',
        dataIndex: 'key',
        key: 'key'
      },
      {
        title: 'Title',
        dataIndex: 'title',
        key: 'title'
      },
      {
        title: 'Order',
        dataIndex: 'order',
        key: 'order'
      },
      {
        title: 'Value',
        dataIndex: 'value',
        key: 'value'
      },
      {
        title: 'Column Type',
        dataIndex: 'columnType',
        key: 'columnType'
      },
      {
        title: 'Format',
        dataIndex: 'format',
        key: 'format'
      },
      {
        title: 'Actions',
        dataIndex: '',
        render: (_, mappingRecord) => (
          <Space size='middle'>
            <Button onClick={() => handleUpdate(mappingRecord)}>
              Edit Mapping
            </Button>
            <Button
              danger
              onClick={() => handleDeleteMapping(mappingRecord, mappings)}
            >
              Delete Mapping
            </Button>
          </Space>
        )
      }
    ]

    return (
      <Table columns={columns} dataSource={mappingData} pagination={false} />
    )
  }

  const columns = [
    {
      title: 'Connection Name',
      dataIndex: 'connectionName',
      key: '0'
    },

    {
      title: 'Actions',
      dataIndex: '',
      render: (_, record) => (
        <Space size='middle'>
          <Button
            style={{ marginLeft: '-30px', marginRight: '-10px' }}
            onClick={() => handleEdit(record)}
          >
            Edit
          </Button>
          <Button onClick={() => handleDelete(record)} danger>
            Delete
          </Button>
          <Button onClick={() => handleCreateMapping(record)} type='primary'>
            Create Mapping
          </Button>
          <Button onClick={() => handleUploadMapping(record)} type='primary'>
            Upload Mapping
          </Button>
          <Button onClick={() => handleAllClearMapping(record)} type='primary'>
            Clear All Mapping
          </Button>
        </Space>
      )
    }
  ]

  return (
    <div>
      <Header />
      <div className={styles['table-container']}>
        <div className={styles['table-button']}>
          <Button onClick={addNewConnection} type='primary'>
            CREATE NEW CONNECTION
          </Button>
        </div>
        <PopupModal
          isVisible={popupOpen}
          onClose={onClose}
          setEditConnection={setEditConnection}
          editConnection={editConnection}
        />
        <MappingModal
          isVisible={mappingPopupOpen}
          onClose={handleCloseMappingModel}
          editMapping={editMapping}
          connectionId={connectionId}
          resetMapping={resetMapping}
          fetchMappings={fetchMappings}
          fetchData={fetchData}
        />
        <UploadModal
          isVisible={uploadPopupOpen}
          onClose={handleCloseUploadModel}
          connectionId={connectionId}
          fetchMappings={fetchMappings}
          fetchData={fetchData}
        />
        <Table
          dataSource={connections}
          columns={columns}
          rowKey='id'
          expandable={{
            expandedRowRender, // Add nested table for mappings
            onExpand: (expanded, record) => {
              if (expanded) {
                fetchMappings(record.id) // Fetch mappings when the row is expanded
              }
            }
          }}
        />
      </div>
    </div>
  )
}

export default Connections
